<template lang="pug">
ods-module.loyalty-programs-detail(v-if="getProgramState")
  h1.loyalty-programs-detail__title
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.codprog') }}
      ods-tag(size="medium") {{ data.codprogr }}
    div.loyalty-programs-detail__description
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.description') }}
      span {{ data.desccpro }}
  div.loyalty-programs-detail__divisor
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.validity') }}
      span {{ this.$t('loyalty.since').toUpperCase() }} {{data.fechvigd | formatDateLocale}} {{ this.$t('loyalty.until').toUpperCase() }} {{data.fechvigh | formatDateLocale}}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.equivalenceRatio') }}
      span {{ data.ratequiv }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.pointsTransferIndicator') }}
      span {{ this.actualizarCampo(data.xtranptn) }}
    //- div.loyalty-programs-detail__flex-33-percent-column
    //-   h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.periodValidity') }}
    //-   span {{ data.pervigen }}
  //- div.loyalty-programs-detail__divisor
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.typeAccount') }}
      span {{ data.codtipcu }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.realtimepointinf') }}
      span {{ data.indptotr }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.immediateReward') }}
      span {{ data.inprinme }}
ods-module.loyalty-programs-detail(v-else v-loading="true" loading-spinner="spinner")
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'GeneralTable',
  computed: {
    ...mapGetters({
      getProgramState: 'getProgramState'
    })
  },
  methods: {
    changeNumbers (data, number) {
      const newNumber = new Intl.NumberFormat(data).format(number)
      return newNumber
    },
    actualizarCampo (data) {
      if (data === 0) {
        return this.$t('loyalty.no')
      }
      if (data === 1) {
        return this.$t('loyalty.yes')
      }
    },
    cambiarCriterio (data) {
      if (data === 0) {
        return this.$t('loyalty.noExpirationDate')
      }
      if (data === 1) {
        return this.$t('loyalty.directedOlder')
      }
      if (data === 2) {
        return this.$t('loyalty.directedNewest')
      }
      if (data === 3) {
        return this.$t('loyalty.customerCategory')
      }
    }
  }
}
</script>
<style lang="scss">
.loyalty-programs-detail{
  .ods-module__body{
    padding: 0;
  }
  &__flex-row{
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   margin-top: rem(16);
  }

  &__flex-33-percent-column{
    width: 33.33%;
    margin-bottom: rem(15);
  }

  &__divisor{
   border: 1px solid #F0F0F0;
   margin: rem(32) 0 rem(32) 0;
  }

  &__title{
    font-size: rem(16);
    line-height: rem(24);
    margin-bottom: rem(16);
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(12);
    line-height: rem(24);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
  }

  &__button{
    border-radius: 6px !important;
    padding: 11px 40px !important;
    width: 84px;
    height: 24px;
  }
}
</style>
